import { motion } from 'framer-motion';
import { resumeData } from '../data/resumeData';
import { FaLinkedin } from 'react-icons/fa';

export default function Intro() {
  const { meta, professionalSummary } = resumeData;

  return (
    <section className="pt-32 pb-20 px-6 bg-black">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-12">
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="w-48 h-48 rounded-full overflow-hidden border-2 border-primary/20"
          >
            <img
              src={meta.profileImage}
              alt={meta.name}
              className="w-full h-full object-cover"
            />
          </motion.div>

          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="flex-1 text-center md:text-left"
          >
            <h1 className="text-4xl md:text-6xl font-display font-bold mb-4 text-white">
              Hi, I'm{' '}
              <span className="text-primary">{meta.name.split(' ')[0]}</span>
            </h1>
            <h2 className="text-xl md:text-2xl text-gray-400 mb-6">
              {meta.title}
            </h2>
            <p className="text-lg max-w-2xl leading-relaxed mb-8 text-gray-300 text-justify whitespace-normal">
              {professionalSummary}
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-center md:justify-start">
              <a
                href={meta.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                 className="flex items-center justify-center px-8 py-3 border-2 border-primary bg-primary text-white rounded-full hover:bg-white hover:text-primary transition-colors duration-300"
              >
                <FaLinkedin className="mr-2 text-lg" />
                LinkedIn
              </a>
              <a
                href="#contact"
                // className="flex items-center justify-center px-8 py-3 border-2 border-primary text-primary rounded-full hover:bg-primary hover:text-white transition-colors"
              //  className="px-8 py-3 bg-primary text-white rounded-full hover:bg-primary/90 transition-colors text-center"
                  className="flex items-center justify-center px-8 py-3 border-2 border-primary bg-primary text-white rounded-full hover:bg-white hover:text-primary transition-colors duration-300"
              >
                Let's Connect
              </a>
              
              {/* <a
                href="#portfolio"
                className="px-8 py-3 border-2 border-primary text-primary rounded-full hover:bg-primary hover:text-white transition-colors text-center"
              >
                View Portfolio
              </a> */}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}